import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/react';

import './header.scss';
import Classes from '../classes/classes';
import Groups from '../groups/groups';
import Tools from '../tools/tools';

import ToastHost from '../toast/toast-host';

function Header(props) {
    const {
        classes,
        productId,
        currentClassName,
        currentClassId,
        updateCurrentClassId,
        editClassName,
        classGroups,
        setShownPassword,
        setIsMinimised,
        studentsLength,
        exportStudents,
        showNewCourses,
        newCoursesAvailabilityCriteria,
        externalClassroomId,
        isSisSchool
    } = props;


    return (
        <header className="header">
            <ToastHost />

            <h1 className="header__title">
                <Trans id={'Page - Title'} />
            </h1>

            <div className="header__tools">
                <div className="header__tool header__tool--classes">
                    <label htmlFor="consoleClassSelector">
                        <Trans id={'Class Dropdown - header'} />
                    </label>
                    <Classes
                        externalClassroomId={externalClassroomId}
                        classes={classes}
                        productId={productId}
                        currentClassName={currentClassName}
                        currentClassId={currentClassId}
                        updateCurrentClassId={updateCurrentClassId}
                        editClassName={editClassName}
                        setIsMinimised={setIsMinimised}
                        isSisSchool={isSisSchool}
                    />
                </div>
                <Groups
                    parentClass="header__tool header__tool--groups"
                    classGroups={classGroups}
                    setShownPassword={setShownPassword}
                    showNewCourses={showNewCourses}
                    newCoursesAvailabilityCriteria={newCoursesAvailabilityCriteria}
                />
            </div>
            <Tools
                parentClass="header__tool header__tool--actions"
                classesLength={classes.length || 0}
                studentsLength={studentsLength}
                exportStudents={exportStudents}
                currentClassId={currentClassId}
                currentClassName={currentClassName}
                isSisSchool={isSisSchool}
            />
        </header>
    );
}

Header.propTypes = {
    classes: PropTypes.array,
    productId: PropTypes.string,
    currentClassName: PropTypes.string,
    currentClassId: PropTypes.number,
    editClassName: PropTypes.func,
    updateCurrentClassId: PropTypes.func,
    setIsMinimised: PropTypes.func,
    isSisSchool: PropTypes.bool,
    classGroups: PropTypes.array,
    setShownPassword: PropTypes.func,
    studentsLength: PropTypes.number,
    exportStudents: PropTypes.func,
    showNewCourses: PropTypes.bool,
    newCoursesAvailabilityCriteria: PropTypes.object,
    externalClassroomId: PropTypes.string
};

export default Header;



// WEBPACK FOOTER //
// ./components/header/header.js